import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getPlansData,
  getTestimonials,
  getOurClients,
  getFeaturesOfFTP,
  getWhatIsFPA,
} from "../store/slices/Home/HomeSlice";
import useAuthChecker from "./Auth/useAuthChecker";
import useStudioPayment from "./useStudioPayment";
import { paymentModalAction } from "../store/slices/Payment/checkoutSlice";
import { useState } from "react";
import { getAxiosInstance } from "../api";
import { toast } from "react-toastify";

export const useHome = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isAuthCompleted } = useAuthChecker();
  const { handleInitPayment } = useStudioPayment();
  const [country, setCountry] = useState([]);

  const {
    testimonialData,
    ourClientsData,
    plansData,
    featuresOfFTPData,
    whatIsFPAData,
    status,
  } = useSelector((state) => state.home);
  const { userProfileData } = useSelector((state) => state.userData);
  const isLoading = status === "loading";

  useEffect(() => {
    getCountryDialCodes();
  }, []);

  const getCountryDialCodes = async () => {
    const api = await getAxiosInstance();
    try {
      let data = await api.get("/country-dial-codes");
      setCountry(data?.data?.result);
    } catch (error) {
      setCountry([]);
    }
  };
  const isPaymentCompleted = () => {
    if (userProfileData.plan_payment_status === 0) {
      return false;
    } else {
      return true;
    }
  };

  const capitalizeFirstLetter = (s) => s && s[0].toUpperCase() + s.slice(1);

  const plans = (renew) => {
    // if (plansData == null) {
    
    dispatch(getPlansData(renew));
    // }
  };

  const testimonials = () => {
    // if (testimonialData == null) {
    dispatch(getTestimonials());
    // }
  };

  const ourClients = () => {
    // if (ourClientsData == null) {
    dispatch(getOurClients());
    // }
  };

  const featuresOfFTP = () => {
    // if (featuresOfFTPData == null) {
    dispatch(getFeaturesOfFTP());
    // }
  };

  const whatIsFPA = () => {
    // if (whatIsFPAData == null) {
    dispatch(getWhatIsFPA());
    // }
  };
  const closePaymentModal = () => {
    dispatch(paymentModalAction(false));
  };

  const buttonCallback = (data,type) => {
    if (isAuthCompleted === false) {
      navigate("/login");
      /********************************************************************************************
       * IF THE USER IS LOGGED OUT IN AND CLICKED ON BUY BUTTON WILL BE REDIRECTED TO REGISTER PAGE *
       ******************************************************************************************/
    } else {
      // if (!userProfileData?.is_package  && isPaymentCompleted() === true && type==="Plan") {
      //   /******************************************************************************************
      //    * IF THE USER IS LOGGED IN AND THE PAYMENT HAS BEEN DONE WILL BE REDIRECTED TO DASHBOARD *
      //    ******************************************************************************************/
      //   navigate("/dashboard");
      // } else {
        /******************************************************************************************************
         * IF THE USER IS LOGGED IN AND THE PAYMENT HAS NOT BEEN DONE WILL BE REDIRECTED TO HDFC PAYMENT PAGE *
         ******************************************************************************************************/
        if (data?.plans_prices[0]?.countries?.country_dial_code == "91") {
          let itemData = {
            isOpen: false,
            item: {},
            type: "Plan",
          };
          dispatch(paymentModalAction(itemData));
          navigate(`/payment/${data.id}`);
        } else if (isAuthCompleted) {
          if(data?.plans_prices?.[0]?.countries?.id && data?.plans_prices?.[0]?.countries?.currency_code){
          let itemData = {
            isOpen: true,
            item: data,
            type: "Plan",
          };
          dispatch(paymentModalAction(itemData));}
          else{
            toast.error("This plan is not available in your country.");
            }
        } else {
          navigate("/login");
        }
        // navigate(`/payment/${data.id}`);

        // handleInitPayment(data);
        // navigate("/plans");
      // }
    }
  };

  return {
    plansData,
    testimonialData,
    ourClients,
    ourClientsData,
    plans,
    plansData,
    featuresOfFTP,
    featuresOfFTPData,
    whatIsFPA,
    whatIsFPAData,
    testimonials,
    capitalizeFirstLetter,
    buttonCallback,
    isPaymentCompleted,
    closePaymentModal,
    status,
    isLoading,
  };
};
